import i18n from "../../../../i18n";

const SLADueIn = i18n.t('manageAutomation.SLADueIn');
const AssignedTo = i18n.t('manageAutomation.AssignedTo');
const IncidentStatus = i18n.t('manageAutomation.IncidentStatus');
const IncidentID = i18n.t('manageAutomation.IncidentID');
const Priority = i18n.t('manageAutomation.Priority');
const OffenceName = i18n.t('manageAutomation.OffenceName');
const UpdatedOn = i18n.t('manageAutomation.UpdatedOn');
const Client = i18n.t('manageAutomation.Client');
const EventCount = i18n.t('manageAutomation.EventCount');
// const IncidentURL = i18n.t('manageAutomation.IncidentURL');
// const SysId = i18n.t('manageAutomation.SysId');
const SourceProvider = i18n.t('manageAutomation.SourceProvider');
const SourceType = i18n.t('manageAutomation.SourceType');
const InstanceIP = i18n.t('manageAutomation.InstanceIP');
const Environment = i18n.t('manageAutomation.Environment');
const AccountID = i18n.t('manageAutomation.AccountID');
const CreatedAt = i18n.t('manageAutomation.CreatedAt');

// const SID = i18n.t('manageAutomation.SID');
// const InstanceStatus = i18n.t('manageAutomation.InstanceStatus');
// const ApplicationName = i18n.t('manageAutomation.ApplicationName');

const INFRA_SECURITY_HEADERS = [

    {
        key: 'incidentId',
        header: IncidentID,
        hidden: false,
        optional: false
    },
    {
        key: 'assigned_to',
        header: AssignedTo,
        hidden: false,
        optional: false
    },
    {
        key: 'incidentStatus',
        header: IncidentStatus,
        hidden: false,
        optional: false
    },
    {
        key: 'priority',
        header: Priority,
        hidden: false,
        optional: false
    },
    {
        key: 'accountId',
        header: AccountID,
        hidden: false,
        optional: false
    },
    {
        key: 'alertName',
        header: OffenceName,
        hidden: false,
        optional: false
    },
    {
        key: 'client',
        header: Client,
        hidden: true,
        optional: true
    },
    {
        key: 'alertCount',
        header: EventCount,
        hidden: false,
        optional: false
    },
    {
        key: 'updatedOn',
        header: UpdatedOn,
        hidden: false,
        optional: false
    },
    {
        key: 'createdAt',
        header: CreatedAt,
        hidden: false,
        optional: false
    },
    {
        key: 'source_provider',
        header: SourceProvider,
        hidden: false,
        optional: false
    },
    {
        key: 'source_type',
        header: SourceType,
        hidden: false,
        optional: false
    },
    {
        key: 'environment',
        header: Environment,
        hidden: true,
        optional: true
    },
    {
        key: 'instanceIp',
        header: InstanceIP,
        hidden: true,
        optional: true
     }
];
export default INFRA_SECURITY_HEADERS;